import JSX from "../../helpers/react.js";

export default function FilterCell({label, collapse, subDivClassName, className, style}: {label?: string|HTMLElement, collapse?: boolean, subDivClassName?: string, className?: string|string[], style?: any}, content: any){
    const classNames = ["filter-cell"];
    if(collapse) classNames.push('collapse')
    if(className) classNames.push(...(typeof className === 'string' ? className.split(' '):className))
    return (
        <div className={classNames} style={style}>
        <div className={subDivClassName}>
            {!!label && <label>{label}</label> }
    {content}
    </div>
    </div>
)
}
